import Plyr from 'plyr/dist/plyr.polyfilled.js';
import Helper from '../helpers/Helper';

export default class VideoPlayer {
    constructor() {
        this.el = null;
        this.player = null;
        this.embedContainer = null;
        this.embedPlyr = null;
        this.embedIframe = null;
        this.loop = false;
        this.defaultVideoId = '330706510';
        this.cookieName = 'video_optinout';
        this.hideModule = true;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }

        // hide module
        if (this.hideModule) {
            document.querySelectorAll('.module-video > *:not(.modulecreate)').forEach((el) => {
                el.remove();
            });
            return;
        }

        this.el = el;
        this.embedContainer = this.el.querySelector('.video__embed-container');

        if (Helper.isInsideEditor()) {
            this.initializeVideo();
            return;
        }

        this.initOptInOut();
    }
    initializeVideo() {
        this.loop = this.embedContainer.getAttribute('data-loop') == 'true';
        this.killVideoPlayer();
        this.buildVideoPlayer();
        this.player = new Plyr(this.embedPlyr, {
            settings: ['captions', 'quality', 'loop']
        });
        if (!this.loop) {
            this.player.on('ended', () => {
                this.player.stop();
            });
        }
    }
    killVideoPlayer() {
        if (this.embedContainer === undefined || this.embedContainer === null) {
            return;
        }
        this.embedContainer.innerHTML = '';
    }
    buildVideoPlayer() {
        this.embedPlyr = document.createElement('div');
        this.embedPlyr.setAttribute('class', 'plyr__video-embed');
        this.embedIframe = document.createElement('iframe');
        this.embedIframe.setAttribute('src', this.videoSource());
        this.embedIframe.setAttribute('class', 'video__object');
        this.embedIframe.setAttribute('allow', 'autoplay; fullscreen');
        this.embedIframe.setAttribute('frameborder', '0');
        this.embedIframe.setAttribute('allowfullscreen', true);
        this.embedIframe.setAttribute('allowtransparency', true);
        this.embedContainer.appendChild(this.embedPlyr);
        this.embedPlyr.appendChild(this.embedIframe);
    }
    videoType() {
        let source = this.getSource();

        if (source.indexOf('vimeo') > 0 || (!isNaN(source) && source !== '')) {
            return 1;
        } else {
            return 2;
        }
    }
    videoId() {
        let source = this.getSource(),
            videoId;

        if (source === '') {
            return this.defaultVideoId;
        }

        if (source.indexOf('vimeo') > 0) {
            videoId = /(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(source)[3];
        } else if (!isNaN(source) && source !== '') {
            videoId = source;
        } else if (source.indexOf('youtu') > 0) {
            source = source.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            videoId = source[2] !== undefined ? source[2].split(/[^0-9a-z_-]/i)[0] : source[0];
        } else {
            videoId = source;
        }
        return videoId;
    }
    videoSource() {
        let videoId = this.videoId(),
            videoType = this.videoType();

        if (videoType === 1) {
            return this.vimeoSource(videoId);
        }
        if (videoType === 2) {
            return this.youtubeSource(videoId);
        } else {
            return this.vimeoSource(this.defaultVideoId);
        }
    }
    youtubeSource(videoId) {
        if (videoId.length !== 11) {
            return this.vimeoSource(this.defaultVideoId);
        }
        if (this.loop) {
            return (
                'https://www.youtube-nocookie.com/embed/' +
                videoId +
                '?origin=window.location&start=1&theme=dark&color=red&autohide=0&modestbranding=0&playsinline=1&showinfo=0&rel=0&autoplay=0&loop=1&playlist=' +
                videoId
            );
        }
        return (
            'https://www.youtube-nocookie.com/embed/' +
            videoId +
            '?origin=window.location&start=1&theme=dark&color=white&autohide=0&modestbranding=0&playsinline=1&showinfo=0&rel=0&autoplay=0&playlist=0'
        );
    }
    vimeoSource(videoId) {
        if (videoId.length < 4 || videoId.length > 11) {
            return this.vimeoSource(this.defaultVideoId);
        }
        if (this.loop) {
            return (
                'https://player.vimeo.com/video/' +
                videoId +
                '?loop=1&byline=false&portrait=false&speed=true&title=false&transparent=0&gesture=media&color=ffffff&autoplay=0&dnt=1'
            );
        }
        return (
            'https://player.vimeo.com/video/' +
            videoId +
            '?byline=false&portrait=false&speed=true&title=false&transparent=0&gesture=media&color=ffffff&autoplay=0&dnt=1'
        );
    }
    initOptInOut() {
        let optin = this.el.querySelector('.video__optin'),
            optinToggler = this.el.querySelector('.video__optin-toggler'),
            optout = this.el.querySelector('.video__optout'),
            optoutToggler = this.el.querySelector('.video__optout-toggler');

        if (this.getCookie(optin.getAttribute('data-provider'))) {
            this.initializeVideo();
            optout.classList.add('video__optout--active');
            optoutToggler.checked = true;
        }

        if (!this.getCookie(optin.getAttribute('data-provider'))) {
            this.setVideoBgImage();
            optin.classList.add('video__optin--active');
            optinToggler.checked = false;
            optout.classList.remove('video__optout--active');
            optoutToggler.checked = false;
        }

        if (optin) {
            optin.addEventListener('click', () => {
                this.initializeVideo();
                this.setCookie(optin.getAttribute('data-provider'));
                optin.remove();
                optout.classList.add('video__optout--active');
                optoutToggler.checked = true;

                if (
                    document.querySelectorAll(
                        '.video__optin[data-provider=' + optin.getAttribute('data-provider') + ']'
                    ).length > 0
                ) {
                    location.reload();
                }
            });
        }

        if (optout) {
            optout.addEventListener('click', () => {
                this.deleteCookie(optout.getAttribute('data-provider'));
                location.reload();
            });
        }
    }
    getSource() {
        return this.embedContainer.getAttribute('data-source')
            ? this.embedContainer.getAttribute('data-source')
            : '';
    }
    setVideoBgImage() {
        let videoBgImage = '',
            videoId = this.videoId(),
            videoType = this.videoType();

        if (videoType === 1 && !(videoId.length < 4 || videoId.length > 11)) {
            videoBgImage =
                '/files/media/images/video/placeholder.jpg?vimeoid=' + videoId + '&w=1920';
        } else if (videoType === 2 && videoId.length === 11) {
            videoBgImage =
                '/files/media/images/video/placeholder.jpg?youtubeid=' + videoId + '&w=1920';
        } else {
            videoBgImage =
                '/files/media/images/video/placeholder.jpg?vimeoid=' +
                this.defaultVideoId +
                '&w=1920';
        }
        this.el.querySelector('.video__optin-bg').style.backgroundImage =
            'url(' + videoBgImage + ')';
    }
    setCookie(providerName) {
        let expires = new Date();
        expires.setTime(expires.getTime() + 3 * 24 * 60 * 60 * 1000);
        document.cookie =
            providerName +
            '_' +
            this.cookieName +
            '=1;expires=' +
            expires.toUTCString() +
            ';path=/';
    }
    getCookie(providerName) {
        let keyValue = document.cookie.match(
            '(^|;) ?' + providerName + '_' + this.cookieName + '=([^;]*)(;|$)'
        );
        return keyValue ? keyValue[2] : null;
    }
    deleteCookie(providerName) {
        document.cookie =
            providerName +
            '_' +
            this.cookieName +
            '=1;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
    }
}
